export default "__VITE_ASSET__2a7533c4__"